// ============================================================================
// AdminPresentersPanel — top-level Presenters library section.
// ============================================================================
// Wraps PresenterManageModal in inline mode.
// ============================================================================

import { useCallback, useEffect, useState } from 'react';
import { api, type Presenter } from '../api';
import { PresenterManageModal } from './PresenterManageModal';

interface Props {
  token: string;
}

export function AdminPresentersPanel({ token }: Props) {
  const [presenters, setPresenters] = useState<Presenter[]>([]);
  const [error, setError] = useState('');

  const refresh = useCallback(() => {
    api.presenters()
      .then((d) => setPresenters(d.presenters))
      .catch((err) => setError(err?.message || 'Could not load presenters.'));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Presenters</h1>
        <p className="text-sm text-gray-600 mt-0.5">
          The shared library of speakers and subject matter experts. Presenters
          you add here become selectable on every event form.
        </p>
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 rounded-md px-3 py-2 text-sm">
          {error}
        </div>
      )}

      <PresenterManageModal
        open={true}
        inline={true}
        onClose={() => {}}
        token={token}
        presenters={presenters}
        onRefresh={refresh}
      />
    </div>
  );
}
